/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import useAPI from "../../../hooks/useAPI";
import FormOnEditRole from "./FormOnEditRole";
import FormOnListPrevilage from "./FormOnListPrevilage";
import FormOnRole from "./FormOnRole";
import TableOnRole from "./TableOnRole";

const RoleLayanan = (props) => {
	const { getOptionAll } = useAPI();
	const BaseUrl = `${url.roleLayanan}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, addData, updateData, deleteData, tableRef } =
		fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [openPrevilage, setOpenPrevilage] = useState(false);
	const [data, setData] = useState();
	const [option, setOption] = useState([]);

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		setData(params);
	};

	const handleOpenCloseFormPrevilage = (params) => {
		setOpenPrevilage(!openPrevilage);
		setData(params);
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/add_role`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_role?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);
		if (action === "editPrevilage")
			result = await updateData(
				`${BaseUrl}/privilege/edit_privilege?id=${data.id}`,
				data,
				handleOpenCloseFormPrevilage
			);
		if (action === "delete")
			result = await deleteData(
				`${BaseUrl}/delete_role?id=${data.id}`,
				data.nama,
				{
					status: false,
				}
			);
		return result;
	};

	const handleOptionPrevilage = async (idRole) => {
		const res = await getOptionAll(
			`${url.roleLayanan}/privilege?id=${idRole}`,
			"role"
		);
		setOption(res.data);
		return res.data;
	};

	return (
		<Grid direction="column" alignItems="center">
			<TableOnRole
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={pageSize}
				fetchAPI={fetchAPI}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
				modalPrevilage={handleOpenCloseFormPrevilage}
			/>
			<FormOnRole
				open={openAdd}
				handleClose={handleOpenCloseFormAdd}
				fetchAPI={fetchAPI}
			/>
			<FormOnEditRole
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
				fetchAPI={fetchAPI}
			/>
			<FormOnListPrevilage
				open={openPrevilage}
				handleClose={handleOpenCloseFormPrevilage}
				option={option}
				setOption={setOption}
				editDataPrevilage={data}
				handleOptionPrevilage={handleOptionPrevilage}
				fetchAPI={fetchAPI}
			/>
		</Grid>
	);
};
export default RoleLayanan;
